import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { DwGridDataSourceService } from '@digiwall/ag-grid';
import {
  CustomerCreditNoteListDto,
  CustomerCreditNoteService,
} from '@digiwall/goliath-documents/proxy';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService, SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { ColDef } from '@ag-grid-community/core';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';
import { BaseInvoiceDocList } from '../../base-invoice-docs/base-invoice-doc-list';
import { ColumnDefinitionsService } from '../../../services';
import { Observable } from 'rxjs';
import { LoadingService } from '@digiwall/core';

@Component({
  selector: 'document-customer-credit-note-list',
  templateUrl: './customer-credit-note-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class CustomerCreditNoteListComponent
  extends BaseInvoiceDocList<CustomerCreditNoteListDto, CustomerCreditNoteService>
  implements OnInit
{
  private _columns: ColDef[] = this.colDefs;

  get columns(): ColDef[] {
    return this._columns;
  }

  constructor(
    service: CustomerCreditNoteService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
    columnDefinitionService: ColumnDefinitionsService,
    loadingService: LoadingService,
  ) {
    super(
      service,
      router,
      route,
      localizationService,
      subscriptionService,
      confirmation,
      datasource,
      injector,
      columnDefinitionService,
      loadingService,
    );

    this.service.hasPeppolConfiguration().subscribeOnce(
      hasPeppolConfiguration => {
        this.hasPeppolConfiguration.set(hasPeppolConfiguration);
      },
      () => {
        this.hasPeppolConfiguration.set(false);
      },
    );
  }

  protected override generateUBLThenSendMultipleObservable(ids: string[]): Observable<number> {
    return this.service.generateUBLThenSendMultiple(this.selectedEntities().map(x => x.id));
  }
}
